export default __webpack_public_path__ + "static/Mallory-Bold-094c4ac821986ddb55cc4fc82470e6cd.woff2";